import React from 'react';
import loadable from '@loadable/component';

const OffboardingComponent = loadable(() => import('./Offboarding.container'));

export const Offboarding = (props) => <OffboardingComponent {...props} />;
